import { useCallback } from 'react';
import classNames from 'classnames';
import useNavigateWithSearch from '../../../../hooks/useNavigateWithSearch';
import ArrowBack from '../../images/circle-arrow-left-gray.svg';
import './ButtonBack.scss';

const DEFAULT_LABEL = 'GO BACK';

const ButtonBack = ({
  children,
  onClick,
  route,
  className,
}) => {
  const navigateWithSearch = useNavigateWithSearch();
  const defaultOnClick = useCallback(
    () => (route ? navigateWithSearch(route) : window.history.back()),
    [navigateWithSearch, route],
  );

  return (
    <button
      className={classNames('ButtonBack', className)}
      type="button"
      onClick={onClick || defaultOnClick}
    >
      <img src={ArrowBack} alt="arrow-back" />
      <span className="BackButton__label">
        {children || DEFAULT_LABEL}
      </span>
    </button>
  );
};

export default ButtonBack;
